import { useState } from "react";
import {
  campusFacilities,
  engineeringCourses,
  lawCourses,
  mbaCourses,
  pharmacyPGCourses,
  pharmacyUGCourses,
  placementsAndIndustryIntegration,
  professionalCourses,
  whyCDGI,
} from "./constant";
import Faq from "./Faq";
import { Link } from "react-router-dom";
import '../../shared/styles/index.css'

const InstitutionHighlights = () => {
  const [showMoreContent, setShowMoreContent] = useState(false);

  const handleShowContent = () => {
    setShowMoreContent(!showMoreContent);
  };

  return (
    <div
      style={{
        padding: "40px",
      }}
    >
      <h1
        style={{
          fontSize: "25px",
        }}
      >
        Chameli Devi Group of Institutions – Best Engineering, Management
        College in Indore, Madhya Pradesh
      </h1>

      <style>
        {`
      @media (max-width: 991.98px) {
        h1 {
          font-size: 20px !important;
        }
      }
    `}
      </style>
      <p>
        Chameli Devi Group of Institutions (CDGI), Indore, is one of the best
        engineering colleges in Madhya Pradesh, offering high-quality,
        industry-aligned UG and PG courses. Backed by over four decades of
        academic excellence and innovation, CDGI is NAAC A+ accredited,
        AICTE-approved, and affiliated with RGPV Bhopal and DAVV Indore. Our
        mission is to create a new generation of future-ready professionals
        through rigorous academics, hands-on learning, and holistic development.
      </p>

      <div>
        <h2
          className="responsive-h2"
          style={{
            fontSize: "22px",
          }}
        >
          Why CDGI Is Recognized Among the Best Engineering Colleges in Madhya
          Pradesh
        </h2>

        <style>
          {`
      @media (max-width: 991.98px) {
        .responsive-h2 {
          font-size: 18px !important;
        }
      }
    `}
        </style>
        <p>
          With a reputation for academic rigor, modern infrastructure, and
          excellent placement support, CDGI has become a trusted destination for
          thousands of students across India.
        </p>
        <div>
          {whyCDGI.map((item) => (
            <ul>
              <li key={item.index}>{item.value}</li>
            </ul>
          ))}
        </div>
      </div>

      {showMoreContent && (
        <>
          <div>
            <h3
              style={{
                fontSize: "19px",
              }}
            >
              Our Courses – UG & PG Programs at CDGI
            </h3>
            <p>
              CDGI offers a wide range of undergraduate and postgraduate
              programs across key disciplines:
            </p>

            <div>
              <h4
                style={{
                  fontSize: "17px",
                }}
              >
                Engineering Courses (UG) – Best Engineering Colleges in Madhya
                Pradesh
              </h4>
              <div>
                {engineeringCourses.map((course) => (
                  <ul>
                    <li >
                      <Link key={course.index} to={course.link} >
                       <p className="text-hover-blue-underline"> {course.name} </p>
                      </Link>
                    </li>
                  </ul>
                ))}
              </div>
            </div>

            <div>
              <h4
                style={{
                  fontSize: "17px",
                }}
              >
                Management Courses (PG)
              </h4>
              <div>
                {mbaCourses.map((course) => (
                  <ul>
                    <li>
                      <Link key={course.index} to={course.link}>
                   <p className="text-hover-blue-underline"> {course.name} </p>
                      </Link>
                    </li>
                  </ul>
                ))}
              </div>
            </div>

            <div>
              <h4
                style={{
                  fontSize: "17px",
                }}
              >
                Pharmacy Courses (UG & PG)
              </h4>
              <div>
                <p>UG Courses:</p>
                <div>
                  {pharmacyUGCourses.map((course) => (
                    <ul>
                      <li>
                        <Link key={course.index} to={course.link}>
                        <p className="text-hover-blue-underline"> {course.name} </p>
                        </Link>
                      </li>
                    </ul>
                  ))}
                </div>
              </div>

              <div>
                <p>PG Course</p>
                <div>
                  {pharmacyPGCourses.map((course) => (
                    <ul>
                      <li>
                        <Link key={course.index} to={course.link}>
                   <p className="text-hover-blue-underline"> {course.name} </p>
                        </Link>
                      </li>
                    </ul>
                  ))}
                </div>
              </div>
            </div>

            <div>
              <h4
                style={{
                  fontSize: "17px",
                }}
              >
                Professional Courses (UG & PG)
              </h4>
              <div>
                {professionalCourses.map((course) => (
                  <ul>
                    <li>
                      <Link key={course.index} to={course.link}>
                   <p className="text-hover-blue-underline"> {course.name} </p>
                      </Link>
                    </li>
                  </ul>
                ))}
              </div>
            </div>

            <div>
              <h4
                style={{
                  fontSize: "17px",
                }}
              >
                Law Courses (UG)
              </h4>
              <div>
                {lawCourses.map((course) => (
                  <ul>
                    <li>
                      <Link key={course.index} to={course.link}>
                  <p className="text-hover-blue-underline"> {course.name} </p>
                      </Link>
                    </li>
                  </ul>
                ))}
              </div>
            </div>
          </div>

          <div>
            <h4
              style={{
                fontSize: "17px",
              }}
            >
              Our Campus, Facilities & Academic Excellence
            </h4>
            <p>
              From state-of-the-art laboratories to digital classrooms and
              hostels, CDGI offers a campus that supports creativity,
              discipline, and lifelong learning.
            </p>

            <div>
              {campusFacilities.map((item) => (
                <ul>
                  <li key={item.index}>{item.description}</li>
                </ul>
              ))}
            </div>
          </div>

          <div>
            <h4
              style={{
                fontSize: "17px",
              }}
            >
              Placements & Industry Integration
            </h4>
            <p>
              With dedicated placement cells and corporate tie-ups, CDGI
              supports your career goals through:
            </p>

            <div>
              {placementsAndIndustryIntegration.map((item) => (
                <ul>
                  <li key={item.index}>{item.description}</li>
                </ul>
              ))}
            </div>
          </div>

          <div>
            <p>CDGI – Committed to Empowering Future Professionals </p>
            <p>
              Chameli Devi Group of Institutions is not just a college—it’s a
              place where potential meets purpose. We are proud to be among the
              best engineering colleges in Madhya Pradesh, and we remain
              committed to shaping confident, capable, and socially responsible
              professionals through our UG & PG programs.
            </p>
          </div>

          <Faq />
        </>
      )}

      <div style={{ display: "flex", justifyContent: "start" }}>
        <button
          style={{
            all: "unset",
            textAlign: "center",
            paddingLeft: "10px",
            paddingRight: "10px",
            paddingTop: "0px",
            paddingBottom: "0px",
            borderRadius: "3px",
            backgroundColor: "#004b9c",
            color: "white",
            cursor: "pointer",
          }}
          onClick={handleShowContent}
        >
          {showMoreContent ? "Read Less" : "Read More"}
        </button>
      </div>
    </div>
  );
};

export default InstitutionHighlights;
